import _defineProperty from '@babel/runtime/helpers/defineProperty';

/* eslint-disable no-cond-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */

var maps = {
  width: {
    0: 'w-0',
    auto: 'w-auto',
    '100%': 'w-full',
    '100vw': 'w-screen',
    'min-content': 'w-min',
    'max-content': 'w-max',
    'fit-content': 'w-fit',
    '50%': 'w-1/2',
    '33%': 'w-1/3',
    '66%': 'w-2/3',
    '25%': 'w-1/4',
    '75%': 'w-3/4',
    '20%': 'w-1/5',
    '40%': 'w-2/5',
    '60%': 'w-3/5',
    '80%': 'w-4/5',
    '190px': 'w-190',
    '80px': 'w-80'
  },
  minWidth: {
    0: 'min-w-0',
    '100%': 'min-w-full',
    'min-content': 'min-w-min',
    'max-content': 'min-w-max',
    'fit-content': 'min-w-fit'
  },
  maxWidth: {
    0: 'max-w-0',
    '100%': 'max-w-full',
    'min-content': 'max-w-min',
    'max-content': 'max-w-max',
    'fit-content': 'max-w-fit'
  },
  height: {
    0: 'h-0',
    auto: 'h-auto',
    '100%': 'h-full',
    '100vh': 'h-screen',
    '100dvh': 'h-dvh',
    'min-content': 'h-min',
    'max-content': 'h-max',
    'fit-content': 'h-fit'
  },
  minHeight: {
    0: 'min-h-0',
    '100%': 'min-h-full',
    'min-content': 'min-h-min',
    'max-content': 'min-h-max',
    'fit-content': 'min-h-fit'
  },
  maxHeight: {
    0: 'max-h-0',
    '100%': 'max-h-full',
    'min-content': 'max-h-min',
    'max-content': 'max-h-max',
    'fit-content': 'max-h-fit'
  },
  order: {
    0: 'order-none',
    1: 'order-1',
    2: 'order-2',
    3: 'order-3',
    4: 'order-4',
    5: 'order-5'
  }
};
var mapUnboundedProp = function mapUnboundedProp(key, value) {
  return maps[key][value];
};
var isUnboundedValue = function isUnboundedValue(key, value) {
  return !(value in maps[key]);
};
var mapUnboundedSizing = function mapUnboundedSizing(key, value) {
  if (isUnboundedValue(key, value)) {
    return {
      style: _defineProperty({}, key, value)
    };
  }
  return {
    classNames: [mapUnboundedProp(key, value)]
  };
};
var mapUnboundedProps = function mapUnboundedProps(props) {
  var className = [];
  var style = {};
  var width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    height = props.height,
    minHeight = props.minHeight,
    maxHeight = props.maxHeight,
    order = props.order;

  // typed mapper
  var utility;
  (utility = maps.width[width]) ? className.push(utility) : style.width = width;
  (utility = maps.minWidth[minWidth]) ? className.push(utility) : style.minWidth = minWidth;
  (utility = maps.maxWidth[maxWidth]) ? className.push(utility) : style.maxWidth = maxWidth;
  (utility = maps.height[height]) ? className.push(utility) : style.height = height;
  (utility = maps.minHeight[minHeight]) ? className.push(utility) : style.minHeight = minHeight;
  (utility = maps.maxHeight[maxHeight]) ? className.push(utility) : style.maxHeight = maxHeight;
  (utility = maps.order[order]) ? className.push(utility) : style.order = order;
  return {
    className: className,
    style: style
  };
};

export { isUnboundedValue, mapUnboundedProp, mapUnboundedProps, mapUnboundedSizing };
//# sourceMappingURL=unboundedProps.js.map
